import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/proceduresEmails.constants';
import { getAll, resend, sendEmails } from 'services/proceduresEmails.services';

export function* proceduresEmailsGetAll(action: AnyAction): Generator {
  try {
    const { limit, page, search, sortKey, sortType } = action;
    const { data }: any = yield call(getAll, limit, page, search, sortKey, sortType);
    yield put({ type: constants.PROCEDURES_EMAILS_ON_GET_ALL_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.PROCEDURES_EMAILS_ON_GET_ALL_FAILED, error });
  }
}

export function* proceduresEmailsResend(action: AnyAction): Generator {
  try {
    const { id } = action;
    const { data }: any = yield call(resend, id);
    yield put({ type: constants.PROCEDURES_EMAILS_ON_RESEND_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.PROCEDURES_EMAILS_ON_RESEND_FAILED, error });
  }
}

export function* proceduresEmailsSendEmails(): Generator {
  try {
    const { data }: any = yield call(sendEmails);
    yield put({ type: constants.PROCEDURES_EMAILS_ON_SEND_EMAILS_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.PROCEDURES_EMAILS_ON_SEND_EMAILS_FAILED, error });
  }
}

export function* proceduresEmailsRefresh(): Generator {
  const table: any = yield select((state) => state.proceduresEmails.table);
  yield put({ type: constants.PROCEDURES_EMAILS_ON_GET_ALL_REQUESTED, ...table });
}

export function* watchProceduresEmails(): Generator {
  yield all([
    takeLatest(constants.PROCEDURES_EMAILS_ON_GET_ALL_REQUESTED, proceduresEmailsGetAll),
    takeLatest(constants.PROCEDURES_EMAILS_ON_RESEND_REQUESTED, proceduresEmailsResend),
    takeLatest(constants.PROCEDURES_EMAILS_ON_SEND_EMAILS_REQUESTED, proceduresEmailsSendEmails),
    takeLatest(
      [
        constants.PROCEDURES_EMAILS_ON_RESEND_SUCCEEDED,
        constants.PROCEDURES_EMAILS_ON_SEND_EMAILS_SUCCEEDED,
      ],
      proceduresEmailsRefresh,
    ),
  ]);
}
